import React, { Component } from 'react'
import 'babel-polyfill'
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import openSocket from 'socket.io-client'
import SocketIndicator from './socketindicator'
import Loginpopup from './components/login'
import PWResetPopup from './components/pwreset'
import Snackbar from '@material-ui/core/Snackbar'
import Appbar from './menu/appbar'
import Preferences from './components/preferences'
import ListLectures from './lecture/list'
import ListLecturesCombined from './lecture/list_combined'
import Lecture from './lecture/main_view'
import Stats from './lecture/stats_view'
import LectureEdit from './lecture/main_edit'
import LectureResults from './lecture/lectureresults'
import {GlobalResults} from './globalresults'
import {isMobile} from 'react-device-detect'
import 'url-search-params-polyfill'
import { login } from './api'
import ax_ins from './ajax'


import './App.css';

const socurl = window.location.hostname.includes('localhost') ? "https://fb.rdheinsberg.de/" : window.location.origin;

const VERSION = 'v1.2.1'

class App extends Component {
  constructor(props){
    super(props)

    this.state={
      access_token : sessionStorage.getItem('access_token') || localStorage.getItem('access_token') || (isMobile && Cookies.get('access_token')),
      online : false,
      open_login : false,
      open_pwreset :false,
      snackbar_open : false,
      snackbarmessage : ""
    }
  }
  gotuser = (userdata,stayloggedin) => {
    this.setState({open_login : false})
    this.setState({access_token : userdata['access_token']});
    console.log(stayloggedin)
    if (stayloggedin == true && isMobile) {
      localStorage.setItem('access_token', userdata['access_token']);}
    else {
      sessionStorage.setItem('access_token', userdata['access_token']) }
    console.log('saved token');
    ax_ins.get('checktoken?jwt='+this.state.access_token).then((response) => {
        console.log(response);
        this.setState({userdata : response.data});
        this.setState({open_login : false});
          if ('ismanager' in response.data) this.setState({ismanager : response.data.ismanager})
        this.open_soc();
    },).catch((error) => {
      console.log(error);
      this.setState({open_login : true});
    })
  }

  open_soc = (atok) => {
     this.setState({socket: openSocket(socurl, {query: {jwt: this.state.access_token || atok}})});
     this.state.socket.on('send auth', data => {
       console.log('got auth id',data.id)
      this.state.socket.emit('connected',{id:data.id})
     });

     this.state.socket.on('info', data => {
       console.log(data);
       this.setState({online : true})
    });
    //  this.state.socket.on('connect', () => this.setState({online : true}));
     this.state.socket.on('new userdata', data => {
       this.setState({userdata : data})
       this.setState({snackbarmessage : 'Benutzerdaten geändert'})
       this.setState({snackbar_open : true})
      })
    if ('ismanager' in this.state.userdata){
        this.setState({ismanager : this.state.userdata.ismanager})
        this.setState({viewstats : this.state.userdata.ismanager})
      } else
      {
        this.setState({ismanager : false})
      }
    if ('username' in this.state.userdata && (this.state.userdata.username == 'heinze.thomas' || this.state.userdata.username == 'bruennen.frank' || this.state.userdata.username == 'dohmen.christoph' || this.state.userdata.username == 'menzel.frank')) {
          this.setState({viewstats : true})
    }
     this.state.socket.on('disconnect', () => this.setState({online:false}));
  }

  PWReset = () =>{
  this.setState({open_login : false})
  this.setState({open_pwreset : true})
  }

  PWReseted = (ok) => {
    this.setState({open_pwreset : false})
    if (ok)
      this.setState({snackbarmessage : 'SMS gesendet'})
    else
      this.setState({snackbarmessage :'Nummer unbekannt'})
    this.setState({snackbar_open : true})
    this.setState({open_login : true})
  }

  internalLogin = () => {
    const exlogin = new URLSearchParams(window.location.search);
    let self = this
    console.log('param',window.location.search,exlogin,exlogin.get('usr'),exlogin.get('pw'))
    if (exlogin.get('usr')) {
      login(exlogin.get('usr'),exlogin.get('pw'))
      .then(function (response) {
      if(response.status === 200){
          self.gotuser(response.data,false);
          return true
      }
      return false
    })
  }
    return false
  }


  componentDidMount () {
    const exlogin = new URLSearchParams(window.location.search);
    if (!isMobile || exlogin.get('token')) {
    let atok = this.state.access_token || exlogin.get('token')
    ax_ins.get('checktoken?jwt='+atok).then((response) => {
        this.setState({access_token:atok})
        console.log(response);
        this.setState({userdata : response.data});
        this.open_soc(atok);
    },).catch((error) => {
      if (!this.internalLogin()){
        this.setState({open_login : true});
      }
    });
    }
    else {
      if (!this.internalLogin()){
        this.setState({open_login : true});
      }
    }
    const url = new URL(window.location)
    url.searchParams.delete('token');
    url.searchParams.delete('usr');
    url.searchParams.delete('pw');
    window.history.replaceState(null, null, url)
  }

  logout = () => {
    console.log('logout')
    localStorage.removeItem('access_token')
    sessionStorage.removeItem('access_token')
    this.setState({open_login : true})
  }




  render() {
    return (
      <Router>
    <div>
        <SocketIndicator online={this.state.online}/>
        <Appbar userdata={this.state.userdata} logout={this.logout} version={VERSION} ismanager={this.state.ismanager}/>
        <Loginpopup open = {this.state.open_login} onGotuser={this.gotuser} resetpw={this.PWReset}/>
        <PWResetPopup open = {this.state.open_pwreset} socket={this.state.socket} pwreseted={this.PWReseted} />
        {this.state.online &&
        <Switch>

                      <Route exact path="/" render={(props) => <ListLecturesCombined userdata={this.state.userdata} viewstats={this.state.viewstats} ismanager={this.state.ismanager} socket={this.state.socket}/>}/>
                      <Route path="/tabs/" render={(props) => <ListLectures userdata={this.state.userdata} viewstats={this.state.viewstats} ismanager={this.state.ismanager} socket={this.state.socket}/>}/>
                      <Route path="/lecture/:id/" render={(props) => <Lecture userdata={this.state.userdata} ismanager={this.state.ismanager} socket={this.state.socket}/>}/>
                      <Route path="/stats/:id/" render={(props) => <Stats userdata={this.state.userdata} ismanager={this.state.ismanager} socket={this.state.socket}/>}/>
                      <Route path="/lectureresults/:id/" render={(props) => <LectureResults userdata={this.state.userdata} ismanager={this.state.ismanager} socket={this.state.socket}/>}/>
                      <Route path="/editlecture/:id/" render={(props) => <LectureEdit userdata={this.state.userdata} ismanager={this.state.ismanager} socket={this.state.socket}/>}/>
                      <Route path="/globalresults/" render={(props) => <GlobalResults userdata={this.state.userdata} ismanager={this.state.ismanager} socket={this.state.socket}/>}/>
                      <Route path="/Einstellungen/" render={(props) => <Preferences userdata={this.state.userdata}  socket={this.state.socket} />}/>
        </Switch>
        }
        <hr />
        <Snackbar
          anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
          }}
          open={this.state.snackbar_open}
          onClose={() => this.setState({snackbar_open : false})}
          autoHideDuration={4000}
          message={this.state.snackbarmessage}
        />
    </div>
    </Router>
    );
  }
}

export default App;
